import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="footer-wrapper">
      <div className="container text-center">
        <div className="footer-logo mb-4" onClick={() => navigate("/")}>
          <img
            src="/assets/images/logo/Black-Logo.png"
            alt="Rasha Abanni Logo"
            className="footer-logo-img"
          />
        </div>

        <div className="footer-icons d-flex justify-content-center gap-4">
          <a
            href="https://www.instagram.com/rasha_abanni/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i
              className="fab fa-instagram"
              style={{ fontSize: "24px", color: "black" }}
            ></i>
          </a>
          <a
            href="https://linktr.ee/rasha.abanni"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i
              className="fas fa-link"
              style={{ fontSize: "24px", color: "black" }}
            ></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
